import AboutComp from "../components/AboutComp";
import PageHeader from "./../components/PageHeader";

const AboutUs = () => {
  return (
    <>
      <PageHeader />
      <AboutComp />
    </>
  );
};

export default AboutUs;
